import {css} from "@panda/css";

import {Modal} from "../../../../components/modal/Modal";
import {HOME_MATCH_RESIGNATION_SURVEY_CONTENT} from "../../../../constants/home_match_resignation_survey_content";
import {homeMatchResignationSurveyOptions} from "../../../../constants/home_match_resignation_survey_options";
import {otherOption} from "../../../../constants/otherOption";

export type HomeMatchResignationSurveyValues = {
    ownAnswer?: string;
    selectedAnswer?: string;
};

interface IProps {
    className?: string;
    onSubmit: (values: HomeMatchResignationSurveyValues) => void | Promise<void>;
}

export const HomeMatchResignationSurvey = (props: IProps) => {
    const {className, onSubmit} = props;
    const {SUBMIT_BUTTON, TITLE} = HOME_MATCH_RESIGNATION_SURVEY_CONTENT;

    return (
        <div className={className ?? surveyContentStyle}>
            <Modal.Layout.RadioSurvey
                allowOwnAnswer
                options={homeMatchResignationSurveyOptions}
                ownAnswerLabel={otherOption.label}
                submitButtonText={SUBMIT_BUTTON}
                title={TITLE}
                onSubmit={onSubmit}
            />
        </div>
    );
};

const surveyContentStyle = css({
    display: "flex",
    flexDirection: "column",
    height: "100%"
});
import {css} from "@panda/css";

import {Modal} from "../../../../components/modal/Modal";
import {HOME_MATCH_RESIGNATION_SURVEY_CONTENT} from "../../../../constants/home_match_resignation_survey_content";
import {homeMatchResignationSurveyOptions} from "../../../../constants/home_match_resignation_survey_options";
import {otherOption} from "../../../../constants/otherOption";

export type HomeMatchResignationSurveyValues = {
    ownAnswer?: string;
    selectedAnswer?: string;
};

interface IProps {
    className?: string;
    onSubmit: (values: HomeMatchResignationSurveyValues) => void | Promise<void>;
}

export const HomeMatchResignationSurvey = (props: IProps) => {
    const {className, onSubmit} = props;
    const {SUBMIT_BUTTON, TITLE} = HOME_MATCH_RESIGNATION_SURVEY_CONTENT;

    return (
        <div className={className ?? surveyContentStyle}>
            <Modal.Layout.RadioSurvey
                allowOwnAnswer
                options={homeMatchResignationSurveyOptions}
                ownAnswerLabel={otherOption.label}
                submitButtonText={SUBMIT_BUTTON}
                title={TITLE}
                onSubmit={onSubmit}
            />
        </div>
    );
};

const surveyContentStyle = css({
    display: "flex",
    flexDirection: "column",
    height: "100%"
});
